module.exports = __webpack_public_path__ + "img/6.c570b74b.webp";